import React, { useState, useRef, useEffect } from 'react'
import { CalendarView } from '@stencil/dcalendar';
import getDateObj from '../../utils/GetDateObj';
import * as S from "./Calendar.styles";
import dateFormat from 'dateformat';
import useOutsideClick from '../../hooks/useOutsideClick';

const Calendar = (props) => {
  const calendarBlockRef = useRef();
  const { dojObj, onUpdateSearch, isCalendarOpen,toggleCalendar} = props;
  const todaysDate = getDateObj();
  const maxDateAllowed = getDateObj();
  maxDateAllowed.setMonth(maxDateAllowed.getMonth() + 12);
  let storedDate = dojObj ? getDateObj(dojObj) : todaysDate;
  let dateObj = storedDate.getTime() > todaysDate.getTime() ? storedDate : todaysDate;

  const [selectedDate, setSelectedDate] = useState(dateObj);
  const getClassName = (dateObj: Date) => {
    const types = ['selectedDate', 'leftactive', 'rightactive', 'partial'];
    return types[0];
  };

  const dateOnClickHandler = dateObj => {
    setSelectedDate(dateObj);
    toggleCalendar(!isCalendarOpen);
    onUpdateSearch({ date: dateFormat(dateObj, 'yyyymmdd') });
  };
  useOutsideClick(calendarBlockRef, () => {
    if(isCalendarOpen){
      toggleCalendar(false);
    }
  });
  return (
    <>
      {isCalendarOpen &&
        <S.CalendarBlockOuterWrapper ref={calendarBlockRef}>
          <CalendarView
            dateConfigForMonthToBeDisplayed={selectedDate || todaysDate}
            minDateAllowed={todaysDate}
            maxDateAllowed={maxDateAllowed}
            renderDateItem={({ value, dateObj, index }) => {
              if (!value) {
                return (
                  <li key={"empty" + index}>
                    <span></span>
                  </li>
                );
              }
              let isValid = true;
              dateObj.setHours(0, 0, 0, 0);
              todaysDate.setHours(0, 0, 0, 0);
              isValid =
                dateObj.getTime() >= todaysDate.getTime() &&
                dateObj.getTime() < maxDateAllowed.getTime();
              return (
                <li
                  className={
                    dateFormat(selectedDate, 'dmmyyyy') === dateFormat(dateObj, 'dmmyyyy')
                      ? getClassName(dateObj)
                      : ''
                  }
                  key={value + dateObj.getTime()}
                  style={isValid ? { color: 'black' } : { opacity: '0.4', color: 'grey' }}
                  onClick={() => {
                    isValid ? dateOnClickHandler(dateObj) : () => { };
                  }}
                >
                  <span>{value}</span>
                </li>
              );
            }}
          />
        </S.CalendarBlockOuterWrapper>
      }
    </>
  )

}

export default Calendar;